import React from 'react';
import InputFlexBox from 'components/container/InputFlexBox';
import styled from 'styled-components';
import { ISupportLanguage } from 'utils/types/storyTypes';
import FormRightContent from './FormRightContent';
import Content from './Content';
import AddLanguageButton from 'components/AddLanguageButton';

interface IProps {
  langList: ISupportLanguage[] | null;
  data: any;
  setData: React.Dispatch<React.SetStateAction<any | null>>;
  conditions: any;
  motions: any;
  setSelectedType: React.Dispatch<React.SetStateAction<string>>;
  selectedType: string;
  projectId: string | undefined;
}

const ContentWrapper: React.FC<IProps> = ({
  langList,
  data,
  setData,
  conditions,
  motions,
  setSelectedType,
  selectedType,
  projectId,
}) => {
  const handleAddNewLine = () => {
    const cloneData = JSON.parse(JSON.stringify(data));
    cloneData.lines.push({
      motion_name: '',
      condition_type: 0,
      line_condition: null,
      sound_name: '',
      localizations: [],
    });
    setData(cloneData);
  };
  return (
    <div>
      <InputFlexBox>
        <ListFormLeftWrapping>
          {data?.lines?.map((el, i) => {
            return (
              <Content
                langList={langList}
                data={data}
                detailData={el}
                index={i}
                setData={setData}
                motions={motions}
                conditions={conditions}
              />
            );
          })}
          <AddLanguageButton
            handleAddLanguage={handleAddNewLine}
            title='새로운 대사 그룹 만들기'
          />
        </ListFormLeftWrapping>
        <ListFormRightWrapping>
          <FormRightContent
            data={data}
            setData={setData}
            langList={langList}
            setSelectedType={setSelectedType}
            selectedType={selectedType}
            projectId={projectId}
          />
        </ListFormRightWrapping>
      </InputFlexBox>
    </div>
  );
};

export default ContentWrapper;

const ListFormLeftWrapping = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  row-gap: 24px;
  margin-right: 1.5rem;
`;
const ListFormRightWrapping = styled.div`
  width: 100%;
`;
